import { z } from 'zod';

/** `POST /v1/members/invites` body (workspace-members spec, 2026-08-20) — `role` excludes
 * `owner` (never invitable, see the design's "Data model" section). */
export const inviteCreateSchema = z.object({
  email: z.string().email().max(320),
  role: z.enum(['member', 'admin']),
});

export type InviteCreateInput = z.infer<typeof inviteCreateSchema>;

/** `PATCH /v1/members/:id` body (workspace-members spec, 2026-08-20) — same role-changeable
 * set as `inviteCreateSchema`; the owner row is never role-changeable (route-layer invariant,
 * not expressible here). */
export const memberRoleChangeSchema = z.object({
  role: z.enum(['member', 'admin']),
});

export type MemberRoleChangeInput = z.infer<typeof memberRoleChangeSchema>;
